<template>
  <div
    class="flex flex-col pt-12 pb-5 px-5 overflow-y-scroll"
    style="max-height: 400px;"
  >
    <FontAwesomeIcon
      :icon="['far', 'times-circle']"
      size="2x"
      class="absolute cursor-pointer text-secondary top-4 right-0 mr-3.5"
      @click="closeModal"
    />
    <RecipeRow
      v-for="recipe in recipes"
      :key="recipe.id"
      :recipe="recipe"
      @click.native="goToRecipe(recipe)"
    />
    <InfiniteLoader v-model="loading" :schema="schema" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import RecipeModal from "@/pages/MyRecipes/components/RecipeModal";
import RecipeRow from "@/pages/MealPlanner/components/RecipeRow";

export default {
  name: "MyRecipesModal",
  components: {
    RecipeRow
  },
  props: {},
  computed: {
    ...mapGetters({
      recipes: "getMyRecipes"
    })
  },
  data() {
    return {
      schema: {
        action: "fetchMyRecipes",
        getter: "getMyRecipes",
        pagination: "getMyRecipesPagination",
        clean: "resetMyRecipes"
      },
      loading: false
    };
  },
  methods: {
    goToRecipe(recipe) {
      this.$modal.show(
        RecipeModal,
        {
          recipe
        },
        {
          name: "RecipeModal",
          classes: "RecipeModal rounded-xl rounded-r-none overscroll-contain",
          transition: "vm-transition--side-card",
          height: "100%",
          maxWidth: 600,
          shiftX: 1.0,
          scrollable: true,
          adaptive: true
        }
      );
    },
    closeModal() {
      this.$modal.hide("MyRecipesModal");
    }
  },
  created() {}
};
</script>

<style></style>
